import { render } from "./OnboardingCalendarSyncPage.vue?vue&type=template&id=0b9f15e6&ts=true"
import script from "./OnboardingCalendarSyncPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingCalendarSyncPage.vue?vue&type=script&lang=ts"

import "./OnboardingCalendarSyncPage.vue?vue&type=style&index=0&id=0b9f15e6&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__